import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';

import { Input, Button } from 'components';

import { ISearchProps } from './Search.types';
import { InputVariant } from '../Input';

const Search = ({ onSearch, ...props }: ISearchProps) => {
  const { t } = useTranslation();

  const [value, setValue] = useState('');

  const onChange = e => {
    setValue(e.target.value);
  };

  const handleSearch = () => {
    onSearch(value);
  };

  return (
    <Space>
      <Input size="small" variant={InputVariant.BORDERED} value={value} onChange={onChange} {...props} />

      <Button size="small" onClick={handleSearch}>
        {t('form.button.search')}
      </Button>
    </Space>
  );
};

export default Search;
